import { PixTransactionsListResponse, PixTransactionsResume } from 'types';

import { priceFactory } from '../price';

export function pixTransactionsResumeFactory(
  params: any = {}
): PixTransactionsResume {
  const {
    walletBalance,
    failedTransferTotal,
    failedTransferCount,
    balanceUpdatedAt,
  } = params;

  return {
    walletBalance: priceFactory(walletBalance),
    failedTransferTotal: priceFactory(failedTransferTotal),
    failedTransferCount: failedTransferCount || 0,
    balanceUpdatedAt: balanceUpdatedAt || 0,
  };
}

export function pixTransactionsListFactory(
  params: any = {}
): PixTransactionsListResponse {
  const { results, pagination, sorts } = params;

  return {
    results: (results || []).map((transaction: any) => ({
      creationTime: transaction.creationTime || 0,
      code: transaction.code || '',
      id: transaction.id || '',
      type: transaction.type || '',
      source: {
        walletType: transaction.source?.walletType || '',
        storeCode: transaction.source?.storeCode,
      },
      target: {
        walletType: transaction.target?.walletType || '',
        storeCode: transaction.target?.storeCode,
      },
      grossAmount: priceFactory(transaction.grossAmount),
      feeAmount: priceFactory(transaction.feeAmount),
      netAmount: priceFactory(transaction.netAmount),
      status: transaction.status || '',
      modifiedTime: transaction.modifiedTime || 0,
      information: transaction.information || '',
    })),
    pagination: {
      count: pagination?.count || 10,
      hasNext: pagination?.hasNext || false,
      hasPrevious: pagination?.hasPrevious || false,
      page: pagination?.page || 0,
      totalCount: pagination?.totalCount || 0,
      totalPages: pagination?.totalPages || 0,
    },
    sorts: sorts || [],
  };
}
